// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2QWu2","location":"Header_location__2zA4G"};